import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  CircularProgress,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableContainer,
  TableBody,
  Paper,
  IconButton,
} from "@mui/material";
import { Link } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import FormatTime from "../../AdsPage/FormatTime";
import LoadingAnimation from "../../Animations/LoadingAnimation";
import { fonts, headingFonts, noOutline } from "../../../Styles/Styles";
import OfferStatusModal from "./OfferStatusModal";
import ConfirmModal from "./ConfirmModal";

const OfferMadeSection = () => {
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [confirmModal, setConfirmModal] = useState({
    open: false,
    offerId: null,
  });
  const [statusModal, setStatusModal] = useState({
    open: false,
    type: "",
    message: "",
  });

  // Fetch offers from API on component mount
  useEffect(() => {
    const fetchOffers = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_SERVER_BASE_URL}/offers/sent-offers`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        const data = await response.json();
        console.log("Fetched offers:", data);
        setOffers(data); // Set fetched offers to state
      } catch (error) {
        console.error("Failed to fetch offers:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchOffers();
  }, []);

  const withdrawOffer = async (offerId) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_SERVER_BASE_URL}/offers/withdraw/${offerId}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      const data = await response.json();

      if (response.ok) {
        setOffers((prevOffers) =>
          prevOffers.filter((offer) => offer._id !== offerId)
        );
        setStatusModal({
          open: true,
          type: "success",
          message: data.message || "Offer withdrawn successfully!",
        });
      } else {
        setStatusModal({
          open: true,
          type: "error",
          message: data.message || "Failed to withdraw offer.",
        });
      }
    } catch (error) {
      setStatusModal({
        open: true,
        type: "error",
        message: "Error withdrawing offer. Please try again.",
      });
    }
  };

  const handleWithdraw = (offerId) => {
    setConfirmModal({ open: true, offerId });
  };

  const confirmWithdraw = () => {
    if (confirmModal.offerId) {
      withdrawOffer(confirmModal.offerId);
    }
    setConfirmModal({ open: false, offerId: null });
  };

  // const handleWithdraw = (offerId) => {
  //   // Show confirmation alert before withdrawing the offer
  //   const isConfirmed = window.confirm(
  //     "Are you sure you want to withdraw this offer?"
  //   );
  //   if (isConfirmed) {
  //     withdrawOffer(offerId); // Proceed with withdrawal
  //   }
  // };

  if (loading) return <LoadingAnimation />;

  return (
    <Box>
      {offers.length === 0 ? (
        <Typography sx={{ ...fonts }}>No offers made.</Typography>
      ) : (
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ ...headingFonts }}>Ad Title</TableCell>
                <TableCell sx={{ ...headingFonts }}>Amount</TableCell>
                <TableCell sx={{ ...headingFonts }}>Message</TableCell>
                <TableCell sx={{ ...headingFonts }}>Status</TableCell>
                <TableCell sx={{ ...headingFonts }}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {offers.map((offer) => (
                <TableRow key={offer._id}>
                  <TableCell sx={{ ...headingFonts }}>
                    {offer.title === "Ad removed by Seller" ? (
                      <span style={{ color: "red" }}>{offer.title}</span>
                    ) : (
                      <Link
                        to={`/ad/${offer.adId}`}
                        style={{ textDecoration: "none", color: "inherit" }}
                      >
                        {offer.title}
                      </Link>
                    )}
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      sx={{ ...fonts }}
                    >
                      <FormatTime createdAt={offer.createdAt} />
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ ...fonts }}>${offer.amount}</TableCell>
                  <TableCell sx={{ ...fonts }}>
                    {offer.offerMessage || "No message"}
                  </TableCell>
                  <TableCell>
                    <Typography
                      sx={{
                        ...fonts,
                        color:
                          offer.status === "accepted"
                            ? "green"
                            : offer.status === "rejected"
                            ? "red"
                            : "gray",
                      }}
                    >
                      {offer.status}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <IconButton
                      onClick={() => handleWithdraw(offer._id)} // Show confirmation before withdrawing
                      color="error"
                      sx={{ ...noOutline }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      <ConfirmModal
        open={confirmModal.open}
        title="Withdraw Offer"
        message="Are you sure you want to withdraw this offer?"
        onClose={() => setConfirmModal({ open: false, offerId: null })}
        onConfirm={confirmWithdraw}
      />
      <OfferStatusModal
        open={statusModal.open}
        type={statusModal.type}
        message={statusModal.message}
        setStatusModal={setStatusModal}
      />
    </Box>
  );
};

export default OfferMadeSection;
